import { WarehouseStock } from '../../models/warehouse-stock.model';

export class ApiGetStockAction {
  static readonly type = '[Api] Get quantity in stock for offerings';
  constructor(public offeringIds: string[]) {}
}

export class ApiGetStockActionSuccessAction {
  static readonly type = '[Api] Get quantity in stock for offerings success';
  constructor(public response: WarehouseStock) {}
}

export class ApiGetStockActionErrorAction {
  static readonly type = '[Api] Get quantity in stock for offerings error';
}
